define("shared/utils/formatters/image-from-unsplash", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object"eaimeta@70e063a35619d71f

  /**
   * Formats a raw response from unsplash
   *
   * @method imageFromUnsplash
   * @param {Object} obj Raw image object
   *
   * @returns {Object} Returns a formatted image Ember object
   */
  function imageFromUnsplash(photo) {
    return _object.default.create({
      captionText: formatCaption(photo),
      description: photo.description || photo.alt_description,
      downloads: photo.downloads,
      downloadLink: photo.links.download,
      exif: photo.exif,
      height: photo.height,
      id: photo.id,
      instagramUsername: photo.user.instagram_username,
      isSelected: false,
      likes: photo.likes,
      links: photo.links,
      source: photo.links.html,
      standardResUrl: photo.urls.regular,
      twitterUsername: photo.user.twitter_username,
      type: 'img',
      url: photo.urls.regular,
      urls: photo.urls,
      user: photo.user,
      userId: photo.user.id,
      username: photo.user.username,
      userProfile: photo.user.links.html,
      views: photo.views,
      width: photo.width
    });
  }

  function formatCaption(obj) {
    if (obj.user) {
      const source = "Media Source: ".concat(obj.links.html);
      const credit = "Photo by ".concat(obj.user.name, " on Unsplash");
      return "".concat(source, "\n").concat(credit);
    }

    return '';
  }

  var _default = imageFromUnsplash;
  _exports.default = _default;
});